var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaInfra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9987 13.3332L8.33203 45.9191L13.8611 52.9911L20.2654 47.9828V85.345H79.732V47.9828L86.1363 52.9911L91.6654 45.9191L79.732 36.5864V23.4569H73.1017V31.2599L49.9987 13.3332Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3926 83.5446V58.9873C59.3926 53.2246 54.7209 48.5527 48.958 48.5527C43.1953 48.5527 38.5234 53.2244 38.5234 58.9873V83.5446",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaInfra);
export default __webpack_public_path__ + "static/media/area_infra.e8cc1ea76f769aa86f1d2c835b62a90e.svg";
export { ForwardRef as ReactComponent };